module.exports = __webpack_public_path__ + "img/radiation-therapy.bd91b73f.png";